import { __rest } from "tslib";
import ICU from './icu/icu';
import { i18n } from './i18n';
export function initI18n(_a) {
    var { icuOptions = {} } = _a, options = __rest(_a, ["icuOptions"]);
    const { parseErrorHandler = undefined } = options;
    const icu = new ICU(Object.assign({ parseErrorHandler, bindI18n: options.bindI18n }, icuOptions));
    return i18n(options, { icu });
}
//# sourceMappingURL=initI18n.js.map